import { render, staticRenderFns } from "./BookingWithCoachCard.vue?vue&type=template&id=0046be38"
import script from "./BookingWithCoachCard.vue?vue&type=script&lang=js"
export * from "./BookingWithCoachCard.vue?vue&type=script&lang=js"
import style0 from "./BookingWithCoachCard.vue?vue&type=style&index=0&id=0046be38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports